import React, { FC, ReactNode } from 'react';

import { Txt } from '../../text';

interface TextCellProps {
  value?: string;
  suffix?: string | ReactNode;
  textAlign: 'left' | 'center' | 'right';
}

const TextCell: FC<TextCellProps> = (props) => {
  const { value, suffix, textAlign } = props;
  return (
    <Txt textAlign={textAlign} fontSize='sm' 
      whiteSpace='pre-wrap'
    >
      {value}
      {suffix && suffix}
    </Txt>
  );
};

export default TextCell;
